// utils/dateFormat.js
import { useEffect, useState } from "react";

export const formatDate = (dateValue) => {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
};

export const formatDateTime = (dateValue) => {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-GB", { 
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }); // e.g. 28/07/2026, 01:17 PM
};

export const formatFileName = (file) => {
  if (!file) return "";

  const dotIndex = file.lastIndexOf(".");
  const extension = dotIndex !== -1 ? file.substring(dotIndex) : "";
 
  const lastThree =
    dotIndex !== -1 ? file.substring(dotIndex - 4, dotIndex) : "";
 
  return `${file.substring(0, 10)}........${lastThree}${extension}`;
};

// अ.क्र. काम मंजुरीचे आर्थिक वर्ष → देयके सादर करण्याची अंतिम मुदत
export const getBillDeadlineForProposalYear = (headCode, proposalYear) => {
  // Rule applies only to HeadCode 3054
  if (!String(headCode || "").includes("3054")) return null;

  const deadlineMap = {
    "2019-2020": "2026-09-20",
    "2020-2021": "2026-09-30",
    "2021-2022": "2026-11-15",
    "2022-2023": "2026-11-15",
    "2023-2024": "2026-12-31",
    "2024-2025": "2026-12-31",
  };

  return deadlineMap[proposalYear] || null; // null => no deadline for this year
};

const DIVISION_ORDER = [
  "Kokan",
  "Pune",
  "Nashik",
  "Chhatrapati Sambhajinagar", // match exactly how it's stored in your data (e.g. "Chh. Sambhajinagar")
  "Amravati",
  "Nagpur",
];

export const getDivisionRank = (division) => {
  const index = DIVISION_ORDER.indexOf(division);
  return index === -1 ? DIVISION_ORDER.length : index; // unknown divisions go last
};

export function useDepartmentFilter(GetMyDepartmentAccess) {
  const [departments, setDepartments] = useState([]); // [{id,name}]
  const [departmentId, setDepartmentId] = useState(""); // "" = all my departments
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      const res = await GetMyDepartmentAccess();
      if (!alive) return;
      const list = res?.data?.departments || [];
      setDepartments(list);
      if (list.length === 1) setDepartmentId(String(list[0].id)); // single department: preselect
      setReady(true);
    })();
    return () => {
      alive = false;
    };
  }, []);

  return { departments, departmentId, setDepartmentId, ready };
}

// Converts any number or numeric string to Indian format: 1234567.5 -> 12,34,567.50
export const formatIndianAmount = (
  value,
  { decimals = 2, currency = false, fallback = "-" } = {}
) => {
  if (value === null || value === undefined || value === "") return fallback;

  const num = Number(String(value).replace(/,/g, ""));
  if (isNaN(num)) return fallback;

  const formatted = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);

  return currency ? `₹ ${formatted}` : formatted;
};